/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import {
  activeEventListenerOptions,
  passiveEventListenerOptions,
  VirtualDndService,
} from './virtual-dnd.service';

@Directive({
  standalone: false,
  selector: '[ghVirtualDndItem]',
})
export class VirtualDndItemDirective<T> implements AfterViewInit, OnDestroy {
  @Input('ghVirtualDndItem') data: T;
  @Input('vhVirtualDndItemDisabled') disabled: boolean;

  private handleEl: HTMLElement;

  constructor(private elementRef: ElementRef,
              private virtualDnd: VirtualDndService) {
    this.onPointerDown = this.onPointerDown.bind(this);
  }

  ngAfterViewInit(): void {
    const handleEl = this.elementRef.nativeElement.querySelector('[ghVirtualDndItemHandle]');
    this.handleEl = handleEl || this.elementRef.nativeElement;

    this.installListeners();
  }

  ngOnDestroy(): void {
    this.uninstallListeners();
  }

  private installListeners(): void {
    if (!this.disabled) {
      this.handleEl.addEventListener('mousedown', this.onPointerDown, activeEventListenerOptions);
      this.handleEl.addEventListener('touchstart', this.onPointerDown, passiveEventListenerOptions);
    }
  }

  private uninstallListeners(): void {
    this.handleEl.removeEventListener('mousedown', this.onPointerDown, activeEventListenerOptions);
    this.handleEl.removeEventListener('touchstart', this.onPointerDown, passiveEventListenerOptions);
  }

  private onPointerDown(event: MouseEvent | TouchEvent): void {
    this.virtualDnd.initDragging(this.data, this.elementRef.nativeElement, event);
  }
}
